import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Link from 'shopper/components/Link';

import ListGroup from 'components/List/ListGroup';
import ListItem from 'components/List/ListItem';

import placeholder from 'lib/placeholder';
import { composeRefs } from 'lib/utils';

const ArticleNavList = ({ getArticleHeadings, scrollTo }, ref) => {
  const containerRef = useRef(null);
  const [headings, setHeadings] = useState([]);

  useEffect(() => {
    const elements = getArticleHeadings();
    const formatted = elements.map((el, index) => ({
      index,
      title: el.textContent,
    }));

    setHeadings(formatted);
  }, []);

  return (
    <Box
      ref={composeRefs(containerRef, ref)}
      className="bg-neutral-high-200 p-4 dark:bg-neutral-low-300"
    >
      <Heading as="h2" size="size3">
        {placeholder('titles.tableContent')}
      </Heading>
      <ListGroup className="mt-4 flex flex-col gap-y-2 px-4" data-nav-list>
        {headings.map(({ index, title }) => (
          <ListItem key={title}>
            <Link
              as="button"
              className="text-start"
              type="primary"
              onClick={() => {
                /**
                 * Get element offset during click to get the most
                 * recent value.
                 */
                const el = getArticleHeadings()[index];

                if (!el) {
                  return;
                }

                scrollTo(el.offsetTop);
                window.location.hash = index;
              }}
            >
              {title}
            </Link>
          </ListItem>
        ))}
      </ListGroup>
    </Box>
  );
};

ArticleNavList.displayName = 'ArticleNavList';

ArticleNavList.propTypes = {
  getArticleHeadings: PropTypes.func.isRequired,
  scrollTo: PropTypes.func.isRequired,
};

export default ArticleNavList;
